// src/pathology/LicenseDetailsFrame.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateAccountVariable } from "../actions/authenActions";

const LicenseDetailsFrame = () => {
  const dispatch = useDispatch();
  const [emails, setEmails] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

  const license_key = useSelector(
    (state) => state.authen.loggedInUser?.license_key,
  );

  const report_email = useSelector(
    (state) => state.authen.loggedInUser?.variables?.report_emails,
  );

  useEffect(() => {
    if (report_email) {
      setEmails(report_email);
    }
  }, [report_email]);

  // email validation
  const validateEmails = (emailStr) => {
    const emailList = emailStr
      .split(":")
      .map((e) => e.trim())
      .filter(Boolean);

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (const email of emailList) {
      if (!regex.test(email)) {
        return false;
      }
    }
    return true;
  };

  const handleSave = async () => {
    setSaved(false);

    if (!validateEmails(emails)) {
      setError("Enter valid email addresses separated by ':'");
      return;
    }

    setError("");
    setLoading(true);

    try {
      await axios.post(`${baseURL}/licensing/api/variable/add/`, {
        license_key,
        variable_name: "report_emails",
        variable_value: emails,
      });

      dispatch(
        updateAccountVariable({
          variables: {
            report_emails: emails,
          },
        }),
      );

      setSaved(true);
    } catch (err) {
      console.error(err);
      setError("Failed to save emails.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={1} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Email Accounts
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Configure additional colon-separated email accounts to receive the daily
        report.
      </Typography>

      <TextField
        label="Email Addresses"
        multiline
        minRows={3}
        fullWidth
        value={emails}
        onChange={(e) => setEmails(e.target.value)}
        placeholder="email1@example.com:email2@example.com"
        sx={{ mb: 2 }}
      />

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {saved && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Emails saved successfully.
        </Alert>
      )}

      <Box display="flex" justifyContent="flex-end">
        <Button variant="contained" onClick={handleSave} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </Button>
      </Box>
    </Paper>
  );
};

export default LicenseDetailsFrame;
